import { render } from "./DiscountUseDetail.vue?vue&type=template&id=c84db192&scoped=true"
import script from "./DiscountUseDetail.vue?vue&type=script&lang=js"
export * from "./DiscountUseDetail.vue?vue&type=script&lang=js"

import "./DiscountUseDetail.vue?vue&type=style&index=0&id=c84db192&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c84db192"]])

export default __exports__